
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { PaymentMethodOption } from "../../model/payment-method-option";
import { SessionStorageService } from "../../services/session-storage.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ShopWindowItem } from "../../model/shop-window-item";
import { DtmService } from "../../../services/dtm.service";
import { environment } from "../../../../environments/environment";
import { CatalogService } from "src/app/shared/services/catalog.service";
import { Dtm, getDtm, Mapping } from "../../enum/dtm";
import { Discount } from "../../model/discount";
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { SuggestionProductModalComponent } from "../suggestion-product-modal/suggestion-product-modal.component";
import { packageSuggestionModalDisplayLogService } from 'src/app/shared/services/packageSuggestionModalDisplayLog.service';

@Component({
    selector: "pme-product",
    templateUrl: "./product.component.html",
    styleUrls: ["./product.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProductComponent implements OnInit {
  @Input() type: string;
  @Input() productData: ShopWindowItem;
  @Input() currentProductData: ShopWindowItem;
  @Input() context: string;
  @Input() periodicity: string;
  @Input() someoneHasDiscountFloatBadge: boolean;
  @Input() selectedToggle: number;
  @Input() isUpgradeWindow?: boolean;
  @Input() redirectUrl: string;
  @Input() returnUrl: string;
  @Input() sugestionModalData: any;
  @Input() isHybridPackage: boolean = false;
  @Input() stackingOnePackage: boolean = false;
  @Output() buyClicked = new EventEmitter<void>();
  @Output() onPackageChangeSelected: EventEmitter<any> = new EventEmitter<any>();
  couponCode: string;
  descomplicaVitrineDiscountPercentage: number;
  showDropdown: boolean = false;
  creditCardDiscountToFrom = [];
  maxInstallmentValue: number;
  maxInstallment: number;
  cashValueString: string;
  cashDiscountValueString: string;
  cashMaxInstallmentValue: string;
  submitting: boolean;
  isTrial: boolean = false;
  classificationIdentifier: string;
  appliedDiscount: string;
  discountFormatted: any;
  degustationDays: number;
  openModalSuggestionFlag: boolean = false;
  isMobile = /mobile|android|iphone|ipad|ipod|blackberry|windows phone/.test(navigator.userAgent.toLowerCase());
  userId = this.sessionStorageService.getUserId();
  businessId = this.sessionStorageService.getBusinessId();
  innerWidth: number;
  onMobile: boolean;
  monthlyValue: number;
  periodicityValue: number;

  verifyBankBillet = (el) => {

    if (el.includes('boleto')) {
      let indexOfFirstDigit = el.search(/\d/);
      //this.discountFormatted = [el.substring(0, indexOfFirstDigit - 1), el.substring(indexOfFirstDigit)];
      this.discountFormatted = [" à", " vista."];
      return true;
    } else {
      this.discountFormatted = null;
      return false;
    }

  };

  verifyBreakLineBefore = (el) => el && el.substring(0, 4) === "<br>";
  removeBreakLine = (el) => el && el.replaceAll("<br>", "");
  verifyBreakLineAfter = (el) => el && el.substring(el.length - 4) === "<br>";

  constructor(
    public catalogService: CatalogService,
    public sessionStorageService: SessionStorageService,
    public router: Router,
    public route: ActivatedRoute,
    public dtmService: DtmService,
    public dialog: MatDialog,
    public packageSuggestionModalDisplayLogService: packageSuggestionModalDisplayLogService
  ) {
    this.innerWidth = window.innerWidth;
    this.onMobile = window.innerWidth <= 548;
  }
  ngOnInit() {
    this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);


    if (this.classificationIdentifier === 'descomplica') {
      this.catalogService.getActiveDescomplicaCoupon().subscribe(
        (coupon: any) => {
          if (coupon) {

            this.couponCode = coupon.identifier;
            this.descomplicaVitrineDiscountPercentage = coupon.deal.value
          }
        },
        (error) => {


        }
      )
    }
    this.submitting = false;
    if (this.productData) {
      this.getMaxInstallment(this.productData.paymentMethods);
      if (this.type !== 'recharge') {
        if (this.productData.paymentMethods && this.productData.paymentMethods.length > 0) {
          this.getMaxInstallment(this.productData.paymentMethods);
          this.cashValueString = this.productData.totalValue.toFixed(2).replace('.', ',');
          this.cashDiscountValueString = this.productData.totalValueBankBillet.toFixed(2).replace('.', ',');
          this.cashMaxInstallmentValue = this.maxInstallmentValue.toFixed(2).replace('.', ',');
        }
        this.monthlyValue = this.calculateValuePerMonth(this.productData.totalValue);
        this.appliedDiscount = (this.productData.appliedDiscounts && this.productData.appliedDiscounts.length > 0) ? this.getTotalDiscount(this.productData.appliedDiscounts) : null;
      }
    }
    if (this.type !== 'recharge') {
      this.getCreditCardDiscountForFloatBadge();
    }

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // Gambs para funcionar adobe analytics customizado
    this.innerWidth = event.target.innerWidth;
    this.onMobile = this.innerWidth <= 548;
  }
  onBuy() {
    this.buyClicked.emit();
  }
  calculateValueAfterPercentageDiscount(baseValue: any, percentage: number = 0) {


    let baseValueNumber = parseFloat(baseValue.replace(',', '.'));
    const result = baseValueNumber - (baseValueNumber * percentage / 100);
    return result.toFixed(2).replace('.', ',');
  }

  calculateValuePerYearAfterPercentageDiscount(baseValue: any) {
    let value = Number(baseValue.replace(',', '.'));
    return (value * 12).toFixed(2).replace('.', ',');
  }


  calculateValuePerMonth(baseValue: number) {
    let monthlyValue = null;

    switch (this.periodicity) {
      case 'Mensal':
        this.periodicityValue = 0;
        monthlyValue = baseValue;
        break;

      case 'Trimestral':
        this.periodicityValue = 3;
        monthlyValue = baseValue / 3;
        break;

      case 'Semestral':
        this.periodicityValue = 6;
        monthlyValue = baseValue / 6;
        break;

      case 'Anual':
        this.periodicityValue = 12;
        monthlyValue = baseValue / 12;
        break;

      default:
        monthlyValue = baseValue;
    }

    return parseFloat(monthlyValue.toFixed(2));
  }

  getMaxInstallment(paymentMethods: Array<PaymentMethodOption>) {
    paymentMethods.forEach((paymentMethod) => {
      if (paymentMethod.identifier === "CREDIT_CARD") {
        this.maxInstallmentValue = paymentMethod.maxInstallmentValue;
        this.maxInstallment = paymentMethod.maxInstallment;

      }
    });
  }

  formatCurrency(value: number) {
    let valueString = value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (valueString.endsWith(",00")) {
      valueString = valueString.slice(0, -3);
    }

    return valueString;
  }

  truncCurrency(value: number) {
    if (!value) return '';
    return Math.trunc(value);
  }


  decimalCurrency(value: number) {
    if (!value) return '';
    let valueString = value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let search = valueString.indexOf(',');
    if (search !== -1) {
      if (valueString.endsWith(",00")) return '';
      return valueString.slice(search);
    }
    return '';
  }

  extractLastWord(productName: string): string {
    const words = productName.trim().split(/\s+/);

    return words[words.length - 1];
  }

  getValuesBasedOnFeatureList(featureList: any[], product: any) {
    let values = [];
    const mainFeatureList = featureList.map((feature) => feature.name);

    mainFeatureList.forEach((mainFeatureName) => {
      const matchingProductFeature = product.featureList.find(
        (productFeature) => productFeature.name === mainFeatureName
      );

      if (matchingProductFeature) {
        const value = matchingProductFeature.toValue ?? matchingProductFeature.fromValue;
        values.push(value);
      } else {
        values.push(null);
      }
    });
    return values;
  }

  navigate($event: MouseEvent) {
    this.submitting = true;

    if (this.isUpgradeWindow) {
      const queryParams = {
        newPlan: this.productData.product.identifier,
        businessId: this.sessionStorageService.getBusinessId(),
        userId: this.sessionStorageService.getUserId(),
        redirectUrl: this.redirectUrl,
        returnUrl: this.returnUrl
      };
      const url = '/auto-atendimento/' + this.sessionStorageService.getClassification() + '/upgrade';

      this.router.navigate([url], { queryParams });
      this.proceedToPurhcase(this.productData);
      return;
    }

    if (!this.productData || this.productData?.disable) {
      this.openErrorDialog('productDisabled', [], this.productData.product.identifier);
      this.sessionStorageService.setOneClickPurchase(false);
      this.sessionStorageService.setPurchaseOrigin('');
      return;
    }

    if (!this.openModalSuggestionFlag && this.sugestionModalData?.suggestion && !this.isHybridPackage && !this.stackingOnePackage) {

      this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, this.classificationIdentifier));
      this.dtmService.userLoaded({
        "businessId": this.businessId || null,
        "userId": this.userId || null,
      });
      this.dtmService.suggestionEvent(this.sugestionModalData.suggestion.product.identifier, this.productData.product.identifier) ;
      this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
        "businessId": this.businessId || null,
        "userId": this.userId || null,
        "jorneyMappingEvent": "Modal de sugestão exibido"
      });

      let dialog = this.dialog.open(SuggestionProductModalComponent, {
        data: this.sugestionModalData,
        panelClass: 'pme-suggestion-product-modal-panel',
        autoFocus: true,
        disableClose: false
      });
      this.openModalSuggestionFlag = true;

      dialog.afterClosed().subscribe((result) => {
        this.openModalSuggestionFlag = false;
        if (result?.approveSugestion){
          this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, this.productData.product.identifier, true, this.productData.suggestion.discountIdentifier).subscribe();

          this.dtmService.clicksModalSuggestion(this.sugestionModalData.suggestion.product.identifier, this.productData.product.identifier,"ACCEPTED");
          this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, this.classificationIdentifier));
          this.dtmService.userLoaded({
            "businessId": this.businessId || null,
            "userId": this.userId || null,
          });
          this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
            "businessId": this.businessId || null,
            "userId": this.userId || null,
            "jorneyMappingEvent": "Sugestão acatada"
          });

          this.sessionStorageService.setPurchaseOrigin('suggestionPackageModal');

          this.proceedToPurhcase(this.sugestionModalData.suggestion);
          return;
        } else {
          if(result?.approveSugestion === false){
            this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, this.productData.product.identifier, false, this.productData.suggestion.discountIdentifier).subscribe();

            this.dtmService.clicksModalSuggestion(this.productData.product.identifier, this.sugestionModalData.suggestion.product.identifier,'REJECTED');
            this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, this.classificationIdentifier));
            this.dtmService.userLoaded({
              "businessId": this.businessId || null,
              "userId": this.userId || null,
            });
            this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
              "businessId": this.businessId || null,
              "userId": this.userId || null,
              "jorneyMappingEvent": "Sugestão rejeitada"
            });

            this.proceedToPurhcase(this.productData);
          } else {
            this.dtmService.clicksModalSuggestion(this.productData.product.identifier, this.sugestionModalData.suggestion.product.identifier, 'CLOSED');

            this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
              "businessId": this.businessId || null,
              "userId": this.userId || null,
              "jorneyMappingEvent": "Sugestão ignorada"
            });

            return;
          }
        };
      });
    } else {

      this.dtmService.customClickEventNewGeneric(this.productData);

      this.proceedToPurhcase(this.productData);
    }
  }

  proceedToPurhcase(productData: ShopWindowItem) {
    if (this.context === 'SHOP_WINDOW') {

      // Se existe uma targetURL no sessionStorage, usa-a pra navegar
      const targetUrl = sessionStorage.getItem('targetUrl');
      if (targetUrl && targetUrl !== '' && !targetUrl.includes('meu-pacote') && !targetUrl.includes('consulta-e-recuperacao-de-dividas')) {
        this.router.navigate([targetUrl]);
      } else if (productData.cardTitle === 'Plano Gratuito') {
        let baseURL = '';
        if (environment.production) {
          baseURL = 'https://www.serasaempreendedor.com.br/';
        } else {
          baseURL = 'https://valfenda-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/';
        }
        document.location.href = baseURL + 'cadastro-deslogado?pathLogado=monitoreClientes';
      } else {
        this.router.navigate(['../identificacao'], { relativeTo: this.route });
      }
      this.sessionStorageService.setProduct(productData.product.identifier);
      this.sessionStorageService.setClassification(productData.product.classificationIdentifier);
      this.sessionStorageService.setClassification(productData.product.classificationName);
    } else if (this.context === 'ACTIVATE_AUTO_RECHARGE') {
      this.onPackageChangeSelected.emit(productData);
      this.sessionStorageService.setProduct(productData.product.identifier);
      this.sessionStorageService.setClassification(productData.product.classificationIdentifier);
      this.sessionStorageService.setClassification(productData.product.classificationName);
    } else if (this.context === 'CHANGE_AUTO_RECHARGE') {
      this.onPackageChangeSelected.emit(productData);
      this.sessionStorageService.setProduct(productData.product.identifier);
      this.sessionStorageService.setClassification(productData.product.classificationIdentifier);
      this.sessionStorageService.setClassification(productData.product.classificationName);
    }


    // Adobe Analytics
    this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);this.dtmService.productsLoaded([{
      classificationName: productData.product.classificationName,
      identifier: productData.product.identifier
    }]);
    this.dtmService.ruleChange('prodClick');
    this.dtmService.sendPageLoadEvent('prodClick');
    return;
  }

  getCreditCardDiscountForFloatBadge() {

    if (this.productData.appliedDiscounts) {
      this.isTrial = this.productData.appliedDiscounts.some(discount => discount.type === "TRIAL");
      this.degustationDays = this.isTrial ? this.productData.appliedDiscounts[0].degustation : 0;
      let creditCardDiscountToFrom = this.productData.mapPaymentMethodAndDiscount[0]["CREDIT_CARD"][0];
      if (!this.isTrial && creditCardDiscountToFrom) {
        let discountaux = this.productData.appliedDiscounts.find(discount => discount.identifier === creditCardDiscountToFrom);
        if (discountaux) {
          this.creditCardDiscountToFrom.push((discountaux.productValue).toFixed(2));
          this.creditCardDiscountToFrom.push((discountaux.productValue - discountaux.discountAmount).toFixed(2));
        }
      }
    }
    return this.creditCardDiscountToFrom;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  get paymentInstallmentValue(): string {
    const creditCardMethod = this.productData.paymentMethods.find(paymentMethod => paymentMethod.identifier === "CREDIT_CARD");
    return creditCardMethod?.maxInstallmentValue.toFixed(2).replace('.', ',');
  }

  get numPaymentInstallment(): number {
    const creditCardMethod = this.productData.paymentMethods.find(paymentMethod => paymentMethod.identifier === "CREDIT_CARD");
    return creditCardMethod?.maxInstallment;
  }

  get baseValue(): string {
    return Number.parseFloat(String(this.productData.baseValue)).toFixed(2).replace('.', ',');
  }

  get totalValueBankBillet(): string {
    return this.productData.totalValueBankBillet.toFixed(2).replace('.', ',');
  }

  getTotalDiscount(discounts: Array<Discount>): string {
    return discounts.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue.deal.slice(0, -1)),
      0) + "%";
  }

  openErrorDialog(dialogData, enableProducts: ShopWindowItem[], productIdentifier) {
    const data = DialogData.fromPreset(dialogData, { enableProducts });
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: dialogData === 'checksum' ? true : false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  toggleDiscountBadgeMobile() {
    return ((!this.productData?.preferred && this.onMobile) && (this.productData.totalValue !== this.productData.discountsSum) && (this.productData.product.classificationIdentifier === 'consulta-e-recuperacao-de-dividas' || this.productData.product.classificationIdentifier === 'plano-mensal-recarga-pontual'));
  }

  togglePreferredBadge() {
    return (this.classificationIdentifier === 'plano-mensal' || this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas');
  }
}
